import i18n from '@fiverr/i18n/singleton';
import type { EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import { ModalType, openFipMigrationModal } from '@fiverr-private/pro_migration';
import { track } from '../events';
import { ICON_URL } from './constants';
import { fetchBusinessPotential } from './fetchData';

const TTL_30_DAYS = 30;

export const ProMigrationCardImpl = {
    getJobInfo: async ({ context, externalServicesInfo }) => {
        const { locale, userId, organizationId } = context;
        const businessUsersKimeraUrl = externalServicesInfo?.businessUsersKimera?.url;
        const isSimpleUser = userId && !organizationId;

        if (!isSimpleUser) {
            return { shouldDisplayJob: false };
        }

        const hasBusinessPotential = await fetchBusinessPotential(businessUsersKimeraUrl);

        if (!hasBusinessPotential) {
            return { shouldDisplayJob: false };
        }

        return {
            shouldDisplayJob: true,
            dismissInfo: {
                isDismissible: true,
                jtbdTTL: TTL_30_DAYS,
            },

            headerText: i18n.t('jobs_tbd.pro_migration.header_text', { $scope: locale }),
            jobPages: [
                {
                    iconUrl: ICON_URL,
                    title: i18n.t('jobs_tbd.pro_migration.title', { $scope: locale }),
                    subtitle: i18n.t('jobs_tbd.pro_migration.subtitle', { $scope: locale }),
                    ctaText: i18n.t('jobs_tbd.pro_migration.cta', { $scope: locale }),
                    biEnrichment: {
                        user: {
                            id: userId,
                        },
                        page: {
                            element: {
                                name: 'JTBD_seamless_migration',
                            },
                        },
                    },
                },
            ],
            clickAction: {
                type: 'custom',
            },
        };
    },
    cardCallbacks: {
        onCardImpression: (args) => {
            track.impression(args?.biEnrichment);
        },
        customActionCallback: () => {
            track.click({
                page: {
                    element: {
                        name: 'JTBD_seamless_migration',
                    },
                },
            });

            openFipMigrationModal({
                variant: ModalType.SeamlessUpgradeToPro,
                payload: {
                    source: 'JTBD_seamless_migration',
                    biEnrichment: {
                        pageElementName: 'JTBD_seamless_migration',
                    },
                },
            });
        },
    },
} satisfies EagerJobsTbdSdk;
